import {
  Truck,
  ShoppingBag,
  Briefcase,
  Factory,
  Building,
  Users,
  Globe,
  Cpu,
  BarChart,
  Shield,
  Zap,
  Target,
  Baby,
  PawPrint,
} from 'lucide-react'

export const iconMap: Record<string, React.ElementType> = {
  Truck,
  ShoppingBag,
  Briefcase,
  Factory,
  Building,
  Users,
  Globe,
  Cpu,
  BarChart,
  Shield,
  Zap,
  Target,
  Baby,
  PawPrint,
}

export const iconOptions = Object.keys(iconMap)
